import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { AuthFormCard } from '@/components/AuthFormCard';
import { AuthFormInput } from '@/components/AuthFormInput';
import { authService } from '@/services/auth-service';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? '';
  const [formData, setFormData] = useState({ password: '', confirmPassword: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(token ? null : 'The link is invalid.');
  const [completed, setCompleted] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      setError('The passwords do not match.');
      return;
    }
    setLoading(true);
    setError(null);
    try {
      await authService.resetPassword(token, formData.password, formData.confirmPassword);
      setCompleted(true);
    } catch (err: any) {
      const data = err.response?.data;
      const apiError = data?.errors
        ? Object.values(data.errors).flat().join(' ')
        : data?.message || data;
      setError(typeof apiError === 'string' ? apiError : 'The link is invalid or has expired.');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormData(previous => ({ ...previous, [event.target.name]: event.target.value }));
    setError(null);
  };

  return (
    <AuthFormCard title="Reset password">
      {completed ? (
        <>
          <p>Your password has been changed. You can now log in.</p>
          <Link className="auth-form-text-link" to="/">Back to login</Link>
        </>
      ) : (
        <form onSubmit={handleSubmit} className="auth-form compact">
          <AuthFormInput id="password" name="password" type="password" value={formData.password} onChange={handleChange} disabled={loading || !token} placeholder="New password" minLength={8} required autoComplete="new-password" />
          <AuthFormInput id="confirmPassword" name="confirmPassword" type="password" value={formData.confirmPassword} onChange={handleChange} disabled={loading || !token} placeholder="Repeat password" minLength={8} required autoComplete="new-password" />
          {error && <div className="auth-form-error">{error}</div>}
          <button type="submit" className="auth-form-button" disabled={loading || !token}>
            {loading ? 'Saving...' : 'Save password'}
          </button>
        </form>
      )}
    </AuthFormCard>
  );
};

export default ResetPassword;
